<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0;">
    <div class="mx-auto" style="width: 90%;">
        <p class="mb-0">
          <a class="btn btn-xs text-light shadow-none align-middle px-0" (click)="closeModal()">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
        <h2 class="text-light mb-0">{{ title }}</h2>
    </div>
  </div>
  <form [formGroup]="requestForm">
        <div class="row my-3 mx-auto" style="width: 90%;">
            <div class="col">
                <div class="row mx-0 mb-3" style="justify-content: space-between;">
                    <div class="col-12">
                        <div class="row mb-2">
                            <mdb-form-control class="custom-shadow">
                                <input mdbValidate mdbInput type="datetime-local" formControlName="binnacle_ot_date" class="form-control">
                                <label mdbLabel class="form-label active">Fecha Mantenimiento</label>
                            </mdb-form-control>
                        </div>
                        <div class="row mb-2 position-relative">
                            <mdb-form-control class="custom-shadow">
                                <textarea mdbValidate mdbInput placeholder="Comentario mantenimiento" formControlName="binnacle_ot_comments" rows="5" class="form-control"></textarea>
                                <label mdbLabel class="form-label">Comentario mantenimiento</label>
                            </mdb-form-control>
                            <!-- <div *ngIf="requestForm?.get('problem')?.touched && requestForm?.get('problem')?.errors?.['required']" class="floating-alert">
                                <span class="error-icon me-2">⚠️</span>Ingrese un problema
                            </div> -->
                        </div>
                        <div class="row table-editor_input-wrapper">
                            <div class="col-md-12">  
                                <div class="custom-file-upload">
                                    <input 
                                        type="file" 
                                        id="photo" 
                                        (change)="onFileSelected($event)" 
                                        accept="image/*" 
                                        class="form-control"
                                    />
                                    <div class="preview-container mt-3">
                                      <img 
                                        *ngIf="imagePreview" 
                                        [src]="imagePreview" 
                                        alt="Previsualización de la imagen" 
                                        class="img-fluid border rounded"
                                        style="max-width: 100%; max-height: 300px;"
                                      />
                                    </div>
                                    <button 
                                      type="button" 
                                      class="btn btn-danger mt-2" 
                                      (click)="removeImage()"
                                    >
                                      Eliminar Imagen
                                    </button>
                                    <div *ngIf="requestForm?.get('photo')?.touched && requestForm?.get('photo')?.errors?.['required']" class="floating-alert mt-2">
                                      <span class="error-icon me-2">⚠️</span>Seleccione una imagen
                                    </div>
                                  </div>
                                <div *ngIf="requestForm?.get('photo')?.touched && requestForm?.get('photo')?.errors?.['required']" class="floating-alert">
                                    <span class="error-icon me-2">⚠️</span>Seleccione una imagen
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="row pt-1" style="justify-content: space-between;">
                                <div class="col-6 px-0">
                                    <button type="button" class="shadow-0 btn btn-md btn-success" (click)="createMaintenance()">
                                        Guardar
                                    </button>
                                </div>
                                <div class="col-6 px-0 text-end">
                                    <button type="button" class="shadow-0 btn btn-md btn-danger" (click)="closeModal()">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>
        </div>
  </form>

  <mdb-loading [show]="loadingFull" [fullscreen]="true">
      <div class="loading-spinner">
          <div class="spinner-border loading-icon" role="status"></div>
          <span class="loading-text">Cargando datos...</span>
      </div>
  </mdb-loading>